import config from '../config'
import render_fragments from './render_fragments'

import $ from 'jquery'

var options = {
	'enable' : true,
	'dom' : {
		'delegator' : 'body',
		'form' : 'form',
		'button' : '.gform_button',
		'identifier' : '[name=gform_submit]'
	},
	'spinner' : '<div class="uk-overlay uk-overlay-default uk-position-cover uk-margin-remove uk-width-1-1"><div class="uk-position-center"><div uk-spinner></div></div></div>'
}

if(options.enable){
	$(options.dom.delegator).on('click', options.dom.button, bind_submit_gravity_form)
}

function show_loader($wrapper, $loader){
	$wrapper.addClass('uk-position-relative').append($loader)
}

function remove_loader($loader){
	$loader.fadeOut(500, function(){
		$loader.remove()
	});
}

function bind_submit_gravity_form(event){
	event.preventDefault();
	event.stopPropagation();
	var $form = $(this).closest(options.dom.form);
	submit_gravity_form($form)
}

function submit_gravity_form($form){

	var $loader = $(options.spinner);
	show_loader($form, $loader);

	var form_data = $form.serialize();
	var id = $form.find(options.dom.identifier).val()

	$.post( window.location.href, form_data + '&gravity_fragment=' + id,  function( data ) {
		render_fragments(data, true)
		remove_loader($loader);
		renderRecaptcha();
	});
	
	return false;
}

function renderRecaptcha() {

    jQuery( '.ginput_recaptcha' ).each( function() {

        var $elem      = jQuery( this ),
            parameters = {
                'sitekey':  $elem.data( 'sitekey' ),
                'theme':    $elem.data( 'theme' ),
	            'tabindex': $elem.data( 'tabindex' )
            };

        if ( ! $elem.is( ':empty' ) ) {
            return;
        }

        if ( $elem.data( 'stoken' ) ) {
            parameters.stoken = $elem.data( 'stoken' );
        }

        grecaptcha.render( this.id, parameters );

	    if ( parameters.tabindex ) {
		    $elem.find( 'iframe' ).attr( 'tabindex', parameters.tabindex );
	    }

    } );

}

window.renderRecaptcha = renderRecaptcha;


// WEBPACK FOOTER //
// ./resources/assets/js/src/gravity_forms_ajax.js